var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 85,
    viewBox: "0 0 77 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3585 35.0589V31.2698C30.3585 29.154 28.6434 27.4404 26.5291 27.4404H7.73469C5.6188 27.4404 3.90527 29.1555 3.90527 31.2698V80.5551C3.90527 82.671 5.62035 84.3845 7.73469 84.3845H72.5582C74.6741 84.3845 76.3876 82.6694 76.3876 80.5551V42.7192C76.3876 40.6034 74.6725 38.8898 72.5582 38.8898H34.191C32.0752 38.8898 30.3616 37.1748 30.3616 35.0604L30.3585 35.0589Z",
    fill: "#02537B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1856 0.000956174L32.4123 0.084995C32.1412 0.0855155 31.9218 0.305725 31.9223 0.576847L32.029 56.1475C32.0295 56.4186 32.2498 56.638 32.5209 56.6375L76.2942 56.5534C76.5653 56.5529 76.7847 56.3327 76.7842 56.0616L76.6775 0.490923C76.6769 0.219801 76.4567 0.000435658 76.1856 0.000956174Z",
    fill: "#9EBAC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4986 0.000956174L30.7253 0.084995C30.4542 0.0855155 30.2348 0.305725 30.2353 0.576847L30.342 56.1475C30.3425 56.4186 30.5627 56.638 30.8339 56.6375L74.6072 56.5534C74.8783 56.5529 75.0977 56.3327 75.0971 56.0616L74.9905 0.490923C74.9899 0.219801 74.7697 0.000435658 74.4986 0.000956174Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M69.2635 19.02L39.9829 19.0762L39.9846 19.9539L69.2652 19.8977L69.2635 19.02Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M69.2713 22.9867L34.8672 23.0527L34.8686 23.7751L69.2726 23.7091L69.2713 22.9867Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M69.2791 27.3246L34.875 27.3906L34.8764 28.113L69.2805 28.047L69.2791 27.3246Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M69.2884 32.0629L34.8843 32.1289L34.8857 32.8513L69.2897 32.7852L69.2884 32.0629Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5568 41.183L34.9023 41.2246L34.9037 41.947L56.5581 41.9054L56.5568 41.183Z",
    fill: "#53B7E8",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M56.5465 36.8637L34.8921 36.9053L34.8935 37.6277L56.5479 37.5861L56.5465 36.8637Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3123 44.972L34.9082 45.0381L34.9096 45.7605L69.3137 45.6944L69.3123 44.972Z",
    fill: "#53B7E8",
    fillOpacity: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3201 49.308L34.916 49.374L34.9174 50.0964L69.3215 50.0304L69.3201 49.308Z",
    fill: "#53B7E8",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3294 54.0463L34.9253 54.1123L34.9267 54.8347L69.3307 54.7686L69.3294 54.0463Z",
    fill: "#53B7E8",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2573 4.4648L34.626 4.5332L34.6475 15.7263L70.2788 15.6579L70.2573 4.4648Z",
    fill: "#53B7E8",
    fillOpacity: 0.61
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9659 33.4863L58.27 33.5068L58.2901 43.9433L68.986 43.9228L68.9659 33.4863Z",
    fill: "#9EBAC6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7033 35.0589V31.2698C26.7033 29.154 24.9882 27.4404 22.8738 27.4404H4.07941C1.96353 27.4404 0.25 29.1555 0.25 31.2698V80.5551C0.25 82.671 1.96508 84.3845 4.07941 84.3845H68.9029C71.0188 84.3845 72.7323 82.6694 72.7323 80.5551V42.7192C72.7323 40.6034 71.0173 38.8898 68.9029 38.8898H30.5358C28.4199 38.8898 26.7064 37.1748 26.7064 35.0604L26.7033 35.0589Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogo);
export default __webpack_public_path__ + "static/media/img_logo.bf6d1952f01c6702b7f8ae84040e4cfb.svg";
export { ForwardRef as ReactComponent };